import apiTypes from 'src/api/optimalprint-sdk.d';
import { AddonVector, AddonType } from 'src/store/addon/types';
import { IClipArt } from 'src/store/addon/types/clipArtTypes';

// Type for old API (numeric IDs)
type LegacyClipArt = apiTypes.AppBundle.Api.Response.ClipArt.V1.ClipArtListV1Response.IClipArt;

// Overloaded function to handle both old and new types
function clipArtToAddon(
  clipArt: IClipArt,
  getPrice: (productId: number) => string,
): AddonVector;
function clipArtToAddon(
  clipArt: LegacyClipArt,
  getPrice: (productId: number) => string,
): AddonVector;
function clipArtToAddon(
  clipArt: IClipArt | LegacyClipArt | any,
  getPrice: (productId: number) => string,
): AddonVector {
  return {
    id: String(clipArt.clipArtId),
    type: AddonType.ADDON_VECTOR,
    name: clipArt.title,
    preview: clipArt.imageUrl,
    price: getPrice(clipArt.productId),
    tags: clipArt.tags || [],
    allowColorChange: clipArt.allowColorChange,
  };
}

export default clipArtToAddon;
